/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect } from "react"
import { useNavigate } from 'react-router-dom'
import { buildHttpPost } from "./utils/backendInterface.js";
import { isDev } from "./utils/helper.js";


const Login = () => {
    const navigate = useNavigate();
    let count = 0;
    let _isDev = isDev();

    useEffect(() => {
        count = count + 1;
        console.log("On page load: " + count);
        if (count === 1 && _isDev) {
            return;
        }
        let activationSuccess = sessionStorage.getItem("activationSuccess");
        let signUpSuccess = sessionStorage.getItem("signUpSuccess");

        if (activationSuccess && activationSuccess === "true") {
            let redirectContainer = document.getElementById("redirect-container");
            if (redirectContainer) {
                let redirectContainerText = document.createElement('h3');
                redirectContainerText.innerText = "Activation successful";
                redirectContainerText.textAlign = "center";
                redirectContainer.appendChild(redirectContainerText);
            }
        } else if(signUpSuccess && signUpSuccess === "true") {
            let redirectContainer = document.getElementById("redirect-container");
            if (redirectContainer) {
                let redirectContainerText = document.createElement('h3');
                redirectContainerText.innerText = "An activation mail\nhas been sent";
                redirectContainerText.textAlign = "center";
                redirectContainer.appendChild(redirectContainerText);
            }
        }
    }, [count]);

    const onSubmitHandler = (event) => {
        event.preventDefault();
        console.log('onSubmitHandler');

        let email = event.target.email.value;
        let password = event.target.password.value;
        let requestParams = new Map();
        requestParams.set("user", email);
        requestParams.set("pass", password);

        function alertContents(httpRequest) {
            if (httpRequest && httpRequest.readyState === XMLHttpRequest.DONE) {
                console.log("httpRequest.status: " + httpRequest.status);
                if (httpRequest.status === 200) {
                    console.log('Login success');
                    let jsonBody = JSON.parse(httpRequest.responseText);
                    let accessToken = jsonBody["accessToken"];
                    sessionStorage.setItem("accessToken", accessToken);
                    navigate('/companies');
                    navigate(0);
                } else if (httpRequest.status === 403) {
                    console.log("Login denied. Status: " + httpRequest.status);
                    alert('Login denied');
                } else if (httpRequest.status === 409) {
                    console.log("User not activated. Status: " + httpRequest.status);
                    alert('User not activated');
                } else {
                    alert("There was a problem with the request: ", httpRequest.status);
                }
            }
        }

        let httpRequest = buildHttpPost("login", requestParams, alertContents);
        httpRequest.sendRequest();
    }

    return (
        <>
            <div className="logo-image-container">
                <img src="/logo-small.png" alt="React Logo" />
            </div>
            <form id="login-form" onSubmit={onSubmitHandler}>
                <div id="redirect-container"></div>
                <h3>Sign In</h3>

                <div className="mb-3" id="login-email">
                    <label>Email address</label>
                    <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        name="email"
                    />
                </div>
                <div className="mb-3" id="login-password">
                    <label>Password</label>
                    <input
                        type="password"
                        className="form-control"
                        placeholder="Vul wachtwoord in"
                        name="password"
                    />
                </div>
                <div className="mb-3">
                    <div className="custom-control custom-checkbox" id="login-remember-checkbox">
                        <input
                            type="checkbox"
                            className="custom-control-input"
                            id="customCheck1"
                        />
                        <label className="custom-control-label" htmlFor="customCheck1">Remember me</label>
                    </div>
                </div>
                <div className="d-grid">
                    <button type="submit" className="btn btn-primary" onClick={() => { console.log('Submit clicked'); }}>Submit</button>
                </div>
                <p className="forgot-password text-right">
                    Forgot <a href="#">password?</a>
                </p>
            </form>
        </>
    );

}




export default Login;
